import React, { useState } from "react";
import css from "./style.module.css";

export default function TagInput({ label, values, onChange, placeholder, helpText }) {
  const [draft, setDraft] = useState("");

  const commit = () => {
    const next = draft.trim();
    if (!next) return;
    if (values.includes(next)) {
      setDraft("");
      return;
    }
    onChange([...values, next]);
    setDraft("");
  };

  const remove = (idx) => {
    onChange(values.filter((_, i) => i !== idx));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      commit();
    } else if (e.key === "Backspace" && !draft && values.length) {
      remove(values.length - 1);
    }
  };

  return (
    <div className="form-group mt-2">
      <label className="form-label">{label}</label>
      <div className={css.chipRow}>
        {values.map((v, i) => (
          <span key={`${v}-${i}`} className={css.chip}>
            {v}
            <button
              type="button"
              className={css.chipRemove}
              aria-label={`Remove ${v}`}
              onClick={() => remove(i)}
            >
              ×
            </button>
          </span>
        ))}
        <input
          type="text"
          className={css.chipInput}
          value={draft}
          placeholder={values.length ? "" : placeholder}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={commit}
        />
      </div>
      {helpText && <small className="text-muted d-block mt-1">{helpText}</small>}
    </div>
  );
}
